import { getVendorSettings, setVendorData } from './helper';
import http from './http';
import { setPosItems } from '../ReduxToolkit/Reducers/CartReducer';

export const updatePosItems = async (updatedProducts, dispatch) => {
  const itemsString = getVendorSettings("pos_items");
  let pos_items = [];

  try {
    pos_items = JSON.parse(itemsString) || [];
  } catch (err) {
    console.warn("Failed to parse pos_items:", err);
    return;
  }

  // Handle single product or array of products
  const productsArray = Array.isArray(updatedProducts) ? updatedProducts : [updatedProducts];
  let hasUpdates = false;

  productsArray.forEach(updatedProduct => {
    const updatedIndex = pos_items.findIndex(item => item.id === updatedProduct.id);
    if (updatedIndex !== -1) {
      pos_items[updatedIndex] = {
        ...pos_items[updatedIndex],
        ...updatedProduct
      };
      hasUpdates = true;
    }
  });

  if (hasUpdates) {
    await http.saveVendorData({ pos_items: JSON.stringify(pos_items) });
    setVendorData({ pos_items: JSON.stringify(pos_items) });
    dispatch(setPosItems(pos_items));
  }
};